import React, {createRef, useEffect, useState} from 'react';
import {
    IonButton,
    IonContent,
    IonItemDivider,
    IonLabel,
    IonModal,
    IonPage,
} from '@ionic/react';
import { useHistory } from 'react-router-dom';
import SignaturePad from "react-signature-canvas"
import ReactSignatureCanvas from "react-signature-canvas"
import {PDFDocument} from 'pdf-lib'
import {Browser} from '@capacitor/browser';
import {ApiService} from "../api/ApiService";
import {toastStore} from "../components/AppToast";
import {config} from "../Constants";
import {Disclosure} from "./Disclosure";
import DefermentsFirstIn from '../components/walkthrough/individualPage/DefermentsFirstIn';
import LoadDetailHeader, { useTransparentHeaderContrast } from '../components/LoadDetailHeader';
import { ChevronRight } from '../components/icons';

interface AdvanceHistory {
    date: string,
    amount: string,
    approved: any
}

interface ownerData {
    address: string,
    areaCode: number,
    city: string,
    email: string,
    name: string,
    phoneNumber: number,
    state: string,
    units: any
}

const Deferment: React.FC = () => {
    const history = useHistory();
    const { onSheet, onIonScroll } = useTransparentHeaderContrast();
    const [mounted, setMounted] = useState(false);

    const [advances, setAdvances] = useState<AdvanceHistory[]>([]);
    const [currentDeferments, setCurrentDeferments] = useState<AdvanceHistory[]>([]);
    const [lesseeSignature, setLesseeSignature] = useState<any>("");
    const [showSigning, setShowSigning] = useState(false);
    const [header] = useState<string>();
    const [ownerData, setOwnerData] = useState<ownerData>();
    const [owesWestern] = useState(false);
    const [showLesseeSignature, setShowLesseeSignature] = useState(true);
    const [showDisclosure, setShowDisclosure] = useState(false);
    const lesseeSigCanvas = createRef<ReactSignatureCanvas>();

    const today = new Date().toLocaleString().slice(0,10).replace(',','')

    useEffect(() => {
      const id = requestAnimationFrame(() => {
        setTimeout(() => setMounted(true), 30);
      });
      return () => cancelAnimationFrame(id);
    }, []);

    useEffect(() => {
        ApiService.defermentsGet('deferment', {}).then(it => processAdvanceHistory(it));
        ApiService.ownerGet('deferment', {}).then(it => setOwnerData(it));
    }, []);

    const b64toBlob = (base64: any) =>
        fetch(base64).then(res => res.blob())

    async function parsePDF(idNumber: number) {
        const formURL = "./assets/deferralAgreement.pdf"
        const pdfFormBytes = await fetch(formURL).then((res) => res.arrayBuffer())
        const pdfDoc = await PDFDocument.load(pdfFormBytes)
        const form = pdfDoc.getForm()
        const fields = form.getFields()
        var lesseeField = form.getTextField('Lessee');
        var lesseeAddressField = form.getTextField('Lessee Address');
        var lessorTitleField = form.getTextField('Lessee Title');
        var lesseeUnit = form.getTextField('UNIT');
        var driverCode = form.getTextField('OWNERCODE');
        var signDate = form.getTextField('Sign Date')
        lesseeField.setText(ownerData?.name)
        lesseeAddressField.setText(ownerData!.address + " " + ownerData!.city + " " + ownerData!.state)
        lessorTitleField.setText("Owner");
        lesseeUnit.setText("Unit: " + ownerData?.units[0]);
        driverCode.setText("Driver Code: " + localStorage.getItem('driverCode')!)
        signDate.setText(today);
        const lesseeSignatureBytes = await fetch(lesseeSignature).then((res) => res.arrayBuffer())
        const lesseeImageSignature = await pdfDoc.embedPng(lesseeSignatureBytes)
        const pages = pdfDoc.getPages()
        const firstPage = pages[0]
        const pngDims = lesseeImageSignature.scale(0.2)
        firstPage.drawImage(lesseeImageSignature, {
            x: firstPage.getWidth() / 2 - pngDims.width / 2 + 65,
            y: firstPage.getHeight() / 2 - pngDims.height / 2 - 150,
            width: pngDims.width,
            height: pngDims.height,
        })
        const usefulData = await pdfDoc.saveAsBase64({dataUri: true})
        addDocument(usefulData, idNumber);
    }

    const save = () => {
        const signed = lesseeSigCanvas.current!.toDataURL()
        setLesseeSignature(signed)
        setShowLesseeSignature(!showLesseeSignature)
    }

    const clear = () => lesseeSigCanvas.current!.clear()

    async function addDocument(file: string, idNumber: number) {
        let tempFile = new Blob([(await b64toBlob(file))], {type: 'application/pdf'})
        ApiService.lpDocUpload('deferment', {
            filename: "deferralAgreement-" + localStorage.getItem('username')! + "-" + idNumber + ".pdf"},
            {file1: {
                fileName: "deferralAgreement-" + localStorage.getItem('username')! + "-" + idNumber + ".pdf",
                file: tempFile
            }}
            ).then(() => {
            toastStore.getState().setSuccessToast('Your deferment request has been submitted.');
            setShowSigning(false);
        });
    }

    function processAdvanceHistory(data: any) {
        let tempArray: any[] = [];
        let tempCurrentArray: any[] = [];
        data.forEach((element: any) => {
            if (element.approved === null) {
                const tempCurrentObj = element
                tempCurrentObj.date = element.date.replace('T', ' ').slice(0, -14);
                tempCurrentArray.push(tempCurrentObj)
            } else {
                const tempObj = element
                tempObj.date = element.date.replace('T', ' ').slice(0, -14);
                tempArray.push(tempObj)
            }
        });
        setCurrentDeferments(tempCurrentArray)
        setAdvances(tempArray);
    }

    async function getDMEmail() {
        ApiService.getDriverManager('load selection', {dmCode: localStorage.getItem('dmCode')!}).then(it => {console.log("dm email", it.email); submitRequest(it)});
    }

    async function submitRequest(dm: any) {
        if (lesseeSignature !== "") {
            ApiService.defermentCreate('deferment', {}).then(it => {
                toastStore.getState().setSuccessToast('Your deferment has been requested.');
                parsePDF(it);
                let emailList = dm.teamLeadEmail !== null ? ["sgregory@westernexp.com", "scarney@westernexp.com", dm.email, dm.teamLeadEmail] : ["sgregory@westernexp.com", "scarney@westernexp.com", dm.email];
                ApiService.sendEmail('deferment', {
                    to: emailList,
                    subject: 'Deferment Requested',
                    body: 'Driver ' + localStorage.getItem("username")?.toUpperCase() + " has request a deferment, go to http://software.westernexp.com/lp-admin-console/deferments to view the deferment"
                });
            });
        }
        else {
            toastStore.getState().setToast('Please save a signature');
            return;
        }
    }

    function getContract(adv: any) {
        if (config.isPlatformSci) {
            toastStore.getState().setToast('This device has no app installed that can open PDF documents.');
            return;
        }
        const deferLink = `https://westernexpressmobile.com/lpdocs/deferralAgreement-${localStorage.getItem('username')?.toUpperCase()}-${adv.id}.pdf?rand=${Math.round(Math.random() * 10000000)}`;
        Browser.open({url: deferLink}).catch(() => {
            toastStore.getState().setToast('Unable to open this document.');
        });
    }

    const goBack = () => {
      if (history.length > 1) history.goBack();
      else history.replace('/Money');
    };

    return (
        <DefermentsFirstIn>
        <IonPage>
            <LoadDetailHeader title="Deferment" onBack={goBack} onSheet={onSheet} />
            {showDisclosure ? <Disclosure onClose={() => setShowDisclosure(false)} /> : null}
            {owesWestern ?
                <IonContent fullscreen className="design-a-content design-a-content--light">
                    <IonItemDivider style={{marginBottom: "2%"}} color="danger">
                        <IonLabel className="ion-text-wrap"><h1 style={{textAlign: "center", padding: "4px"}}> You are in the owing positions and cannot request a personal advance.</h1></IonLabel>
                    </IonItemDivider>
                    <IonButton expand="block" className="home" fill="outline" color="primary" strong size="large" href="/Drive">Back</IonButton>
                </IonContent> :

                <IonContent
                  fullscreen
                  className="design-a-content design-a-content--light"
                  scrollEvents={true}
                  onIonScroll={onIonScroll}
                >
                    <IonModal isOpen={showSigning} cssClass='my-custom-class'>
                        <div className="design-a design-a--mounted" style={{ minHeight: '100%', background: 'var(--home-app-bg)' }}>
                            <div className="home-sheet advance-sheet" style={{ paddingTop: 32 }}>
                                <div className="advance-card">
                                    {header ? <div className="advance-card__title">{header}</div> : null}
                                    <div className="advance-card__title">Sign deferment agreement</div>
                                    <p className="advance-card__body">
                                        By signing this page you agree to the terms of the Deferral clause of your
                                        Lease Agreement with New Horizons, LLC.
                                    </p>
                                    <p className="advance-card__body">
                                        By signing, I agree to this document, the{' '}
                                        <span
                                            style={{ color: 'var(--home-accent)', textDecoration: 'underline', cursor: 'pointer' }}
                                            onClick={() => setShowDisclosure(true)}
                                        >
                                            Consumer Disclosure
                                        </span>
                                        {' '}and to utilize electronic signatures.
                                    </p>
                                    <p className="profile-field__label" style={{ marginTop: 12 }}>Lessee Signature</p>
                                    <div
                                        hidden={!showLesseeSignature}
                                        style={{ textAlign: "center", width: "100%", overflow: "hidden", backgroundColor: "white", margin: "8px 0", borderRadius: "16px", border: "1px solid var(--home-ring-track)" }}
                                    >
                                        <SignaturePad
                                            ref={lesseeSigCanvas}
                                            canvasProps={{width: 500, height: 175, className: 'sigCanvas'}}
                                        />
                                    </div>
                                    <div style={{ display: "flex", gap: 12 }}>
                                        {showLesseeSignature ? (
                                            <button type="button" className="profile-cancel" style={{ marginTop: 0, flex: 1 }} onClick={save}>Save</button>
                                        ) : (
                                            <button type="button" className="profile-cancel" style={{ marginTop: 0, flex: 1 }} onClick={save}>Re-sign</button>
                                        )}
                                        {showLesseeSignature ? (
                                            <button type="button" className="profile-cancel" style={{ marginTop: 0, flex: 1 }} onClick={clear}>Clear</button>
                                        ) : null}
                                    </div>
                                    <button type="button" className="profile-submit" onClick={() => getDMEmail()}>Submit</button>
                                    <button
                                        type="button"
                                        className="profile-cancel"
                                        onClick={() => { setShowSigning(false); clear(); setShowLesseeSignature(!showLesseeSignature) }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </IonModal>

                    <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
                        <div className="home-hero advance-hero">
                            <div className="advance-hero__eyebrow">Pay</div>
                            <div className="advance-hero__title home-display">Deferment</div>
                            <div className="advance-hero__meta">Defer your next lease payment</div>
                        </div>

                        <div className="home-sheet advance-sheet">
                            <div className="advance-card">
                                <div className="advance-card__title">Request deferment</div>
                                <p className="advance-card__body">
                                    If approved, your lease payment will not be subtracted from your lease on your
                                    next settlement.
                                </p>
                                <button
                                    type="button"
                                    id="western-button"
                                    className="profile-submit"
                                    onClick={() => setShowSigning(true)}
                                >
                                    Request Deferment
                                </button>
                            </div>

                            <div className="photo-card">
                                <div className="inspection-card__title">Pending deferments</div>
                                {currentDeferments.length === 0 ? (
                                    <p className="photo-empty">No pending deferments.</p>
                                ) : (
                                    <div className="inspection-list">
                                        {currentDeferments.map((defer, idx) => (
                                            <div className="inspection-row" key={idx}>
                                                <span className="inspection-row__label">
                                                    {defer.date.substr(5) + '-' + defer.date.substr(0, 4)}
                                                </span>
                                                <span className="trip-tile__tag">
                                                    {defer.approved === null ? "Pending" : ""}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div className="photo-card">
                                <div className="inspection-card__title">Deferment history</div>
                                {advances.length === 0 ? (
                                    <p className="photo-empty">No deferment history yet.</p>
                                ) : (
                                    <div className="inspection-list">
                                        {advances.map((adv, idx) => (
                                            <button
                                                type="button"
                                                className="history-load"
                                                key={idx}
                                                onClick={() => getContract(adv)}
                                            >
                                                <div className="history-load__body">
                                                    <div className="history-load__meta">
                                                        {adv.date.substr(5) + '-' + adv.date.substr(0, 4)}
                                                    </div>
                                                </div>
                                                <span className="trip-tile__tag" style={adv.approved !== 0 ? undefined : { color: '#c23b2f' }}>
                                                    {adv.approved !== 0 ? "Approved" : "Rejected"}
                                                </span>
                                                <ChevronRight />
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </IonContent>
            }
        </IonPage>
        </DefermentsFirstIn>
    );
};

export default Deferment;
